import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getCustomFormQuestion, selectLabelItems, setLabelItems } from "slices";

import ShowQuestion from "./ShowQuestion";

const CustomFormQuestion = ({ setQuestionDisabled, customQuestions, setCustomQuestions }) => {
  const prevLabel = useSelector(selectLabelItems);
  const customFormQuestion = useSelector(getCustomFormQuestion);

  const dispatch = useDispatch();
  const lastPersistedRef = useRef(null);

  useEffect(() => {
    if (Object.keys(customQuestions || {}).length > 0) {
      const stringified = JSON.stringify(customQuestions);

      // Only dispatch if value actually changed to prevent unnecessary updates
      if (stringified !== lastPersistedRef.current) {
        lastPersistedRef.current = stringified;

        dispatch(
          setLabelItems({
            ...prevLabel,
            custom_questions: stringified,
          })
        );
      }
    }
  }, [customQuestions, prevLabel, dispatch]);

  useEffect(() => {
    const isRequiredFieldsFilled = Object.keys(customFormQuestion || {})
      .filter((key) => customFormQuestion[key].isRequired)
      .every((key) => {
        const formQuestion = customFormQuestion[key];
        const customAnswer = customQuestions[key]?.answer;

        return formQuestion.isRequired && customAnswer !== undefined && customAnswer !== null && customAnswer !== "";
      });

    setQuestionDisabled(!isRequiredFieldsFilled);
  }, [customFormQuestion, customQuestions]);

  return customFormQuestion ? (
    <div className="hayley-mt-3 hayley-w-full hayley-space-y-3">
      {Object.keys(customFormQuestion || {}).map((v, i) => (
        <ShowQuestion question={customFormQuestion[v]} objKey={v} key={i} customQuestions={customQuestions} setCustomQuestions={setCustomQuestions} />
      ))}
    </div>
  ) : null;
};

export default CustomFormQuestion;
